import { render, staticRenderFns } from "./Swot.vue?vue&type=template&id=37ee9866"
import script from "./Swot.vue?vue&type=script&lang=js"
export * from "./Swot.vue?vue&type=script&lang=js"
import style0 from "./Swot.vue?vue&type=style&index=0&id=37ee9866&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports